import { render, staticRenderFns } from "./sampleOrderItemLabelPrintView.vue?vue&type=template&id=5bbba474&"
import script from "./sampleOrderItemLabelPrintView.vue?vue&type=script&lang=js&"
export * from "./sampleOrderItemLabelPrintView.vue?vue&type=script&lang=js&"
import style0 from "./sampleOrderItemLabelPrintView.vue?vue&type=style&index=0&id=5bbba474&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports